import Vue from 'vue';
import Vuex from 'vuex';

const state = {
  // 凭证
  token: window.localStorage.getItem('token') || null,
  // openId
  openId: window.localStorage.getItem('openId') || null,
  // 切换状态( move-left | move-right )
  states: '',
  // 页面参数
  viewParams: JSON.parse(window.localStorage.getItem('viewParams')) || {},
};

const getters = {
    token: state => state.token,
    openId: state => state.openId,
    states: state => state.states,
    viewParams: state => state.viewParams
};

const mutations = {
    // 保存token
    saveToken(state, data) {
      state.token = data;
      window.localStorage.setItem('token', data);
    },
    // 保存token
    saveOpenId(state, data) {
      state.openId = data;
      window.localStorage.setItem('openId', data);
    },
    // 切换状态
    setTransition(state, data) {
        state.states = data;
    },
    // 保存页面参数
    saveViewParams(state, data) {
      if (data) {
        state.viewParams = data;
        window.localStorage.setItem('viewParams', JSON.stringify(data));
      }
    }
};

Vue.use(Vuex);

export default new Vuex.Store({
  state,
  getters,
  mutations
});
